import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  noop,
  sortBy,
} from 'lodash';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { HighlightText } from 'components';

class StoreTableRow extends Component {
  static propTypes = {
    data: PropTypes.shape({
      image: PropTypes.string,
    }).isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    searchText: PropTypes.string,

    innerRef: PropTypes.func,
    onImageClick: PropTypes.func,
  };

  static defaultProps = {
    innerRef: noop,
    searchText: '',
    onImageClick: noop,
  };

  state = {
    currentTime: new Date().getTime(),
    storeData: [],
  };

  componentWillMount() {
    const { data } = this.props;
    this.setState({ storeData: data });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ storeData: nextProps.data });
    }
  }

  getDetailedData = () => {
    const { onImageClick } = this.props;
    const { storeData } = this.state;
    const detailData = [];
    const image = storeData.image || null;
    let packRowCount = 0;
    const sortedStoreData = storeData;
    sortedStoreData.packrows = sortBy(sortedStoreData.packrows, 'count');
    sortedStoreData.packrows.forEach((packrow, index) => {
      packRowCount++;
      if (packRowCount > 1) {
        detailData.push({
          ...storeData,
          ...packrow,
          category: storeData.productData.category,
          bulkTotalQty: 0,
          hide: [
            'status',
            'category',
            'name',
            'subname',
            'sourcename',
            'updatedAt',
            'action',
            'qty',
            'description',
            'tags',
            'approved',
          ],
          id: storeData.id,
          index,
          name: storeData.productData.name,
          subname: storeData.productData.subname,
        });
        return;
      }
      detailData.push({
        ...storeData,
        ...packrow,
        bulkTotalQty: storeData.packrows[0].isBulk ? storeData.availableQuantity : 0,
        action: (
          <div className="group-item-action">
            <img
              src={image || ''}
              alt=""
              style={{
                objectFit: 'unset',
                height: 40,
                width: 40,
                marginRight: 5,
                cursor: 'pointer',
              }}
              onClick={onImageClick}
            />
          </div>
        ),
        category: storeData.productData.category,
        id: storeData.id,
        index,
        isMinCount: true,
        name: storeData.productData.name,
        subname: storeData.productData.subname,
      });
    });

    return detailData;
  }

  render() {
    const { fields, innerRef, searchText } = this.props;
    const { currentTime } = this.state;
    const rowClassName = 'normal';
    const detailData = this.getDetailedData();
    return (
      <TableRow className={rowClassName} ref={innerRef} key={currentTime}>
        {
          fields.map((field, index) => (
            <TableCell
              colSpan={field.colSpan || 1}
              key={index}
              style={{ verticalAlign: 'top',width: field.name === "description"  ? '120px' : '' }}
            >
              {
                detailData.map((row, index) => {
                  const value = field.render ? field.render(row) : (row.isSeparator ? '' : row[field.name]);
                  const title = field.title ? (
                    typeof field.title === 'function' ? field.title(row) : field.title
                  ) : value;
                  const searchedValue = !field.searchDisabled && !field.render && searchText
                    ? <HighlightText text={value} highlight={searchText} /> : value;
                  const className = field.overflowHidden ? 'overflow-hidden' : typeof field.className === 'function' ? field.className(row) : field.className;
                  const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;

                  return (
                    <div
                      className={`${className || ''} pack-row`}
                      key={index}
                      title={title}
                    >
                      {!isEmpty && searchedValue}
                    </div>
                  );
                })
              }
            </TableCell>
          ))
        }
      </TableRow>
    );
  }
}

export default StoreTableRow;
